import wpdmIcons from "../../libs/icons";
import LinkTemplates from "../../libs/link-templates";
import Sortable from "../../libs/sortable";
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';

const {InspectorControls} = wp.editor;
const {TextControl, TextareaControl, SelectControl, FormToggle, ServerSideRender, Modal, Button, PanelBody} = wp.components;
const {registerBlockType} = wp.blocks;
const {withState} = wp.compose;
const { __ } = wp.i18n;
const animatedComponents = makeAnimated();


registerBlockType('download-manager/datatable', {
    title: 'All Downloads Table',

    description: 'List all downloads in a searchable and sortable table',

    keywords: [
        __( 'download manager digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'product category categories' )
    ],

    icon: wpdmIcons.table(),

    category: 'wpdm-blocks',

    attributes: {
        login: {
            type: 'boolean',
            default: false
        },
        categories: {
            type: 'string',
            default: ""
        },
        include_children: {
            type: 'boolean',
            default: false
        },
        operator: {
            type: 'string',
            default: "IN"
        },
        xcats: {
            type: 'string',
            default: ""
        },
        tag: {
            type: 'string',
            default: ""
        },
        tag__not_in: {
            type: 'string',
            default: ""
        },
        author: {
            type: 'string',
            default: ""
        },
        author__not_in: {
            type: 'string',
            default: ""
        },
        items_per_page: {
            type: 'string',
            default: "10"
        },
        toolbar: {
            type: 'string',
            default: '1'
        },
        paging: {
            type: 'string',
            default: "1"
        },
        cols: {
            type: 'string',
            default: ""
        },
        colheads: {
            type: 'string',
            default: ""
        },
        orderby: {
            type: 'string',
            default: ""
        },
        order: {
            type: 'string',
            default: ""
        },
        async: {
            type: 'string',
            default: "1"
        },
        template: {
            type: 'string',
            default: 'link-template-panel'
        },
        className: {
            type: 'string',
            default: ''
        }
    },

     edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }

        function onSelectCategory(categories) {
            var selected_cats = [];
            jQuery.each(categories, function (index, category) {
                selected_cats.push(category.value);
            });
            console.log(selected_cats.join(','));
            setAttributes({ categories: selected_cats.join(',') });

        }

         function onExcludeCategory(categories) {
             var selected_cats = [];
             jQuery.each(categories, function (index, category) {
                 selected_cats.push(category.value);
             });
             console.log(selected_cats.join(','));
             setAttributes({ xcats: selected_cats.join(',') });

         }

        function selectedCats(cats) {
            var selected_cats = [];
            cats = cats.split(',');
            jQuery.each(wpdm_categories, function (index, category) {
                if(cats.indexOf(category.value) !== -1){
                    selected_cats.push(category);
                }
            });
            return selected_cats;
        }

        function updateColumns(columns) {
            let cols = [];
            let colheads = [];
            console.log(columns);
            jQuery.each(columns, function (index, column) {
                cols.push(column.field);
                colheads.push(column.label);
            });
            setAttributes({cols: cols.join('|'), colheads: colheads.join('|')})
        }

         function _delete(columns) {
             let cols = [];
             let colheads = [];
             console.log(columns);
             jQuery.each(columns, function (index, column) {
                 cols.push(column.field);
                 colheads.push(column.label);
             });
             setAttributes({cols: cols.join('|'), colheads: colheads.join('|')})
         }

         function prepareColumns() {
             const columnsDefaults = [
                 {label: 'Title', field: 'title'},
                 {label: 'Category', field: 'categories'},
                 {label: 'Update Date', field: 'update_date'},
                 {label: 'Tags', field: 'tags'},
                 {label: 'Action', field: 'action_buttons'}
             ];
             let  columns = [];
             let  cols = attributes.cols.split('|');
             let  colheads = attributes.colheads.split('|');
              jQuery.each(cols, function (index, column) {
                  columns.push({label: colheads[index], field: column});
              });
              if(columns.length  === 0) columns = columnsDefaults;
             return columns;
         }





        return ([
            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>

                        <div className={"form-group"}>
                            <FormToggle
                                id={"login"}
                                checked={attributes.login}
                                onChange={login => {
                                    setAttributes({login: login.target.checked});
                                }}
                            />
                            <label htmlFor={"login"} style={{paddingLeft: "5px"}}> Members Only Access</label>
                        </div>
                    </PanelBody>
                    <PanelBody title={"Table Columns"}>
                            <Sortable list={prepareColumns()} onDelete={_delete} onUpdate={updateColumns} />
                    </PanelBody>
                    <PanelBody title={"Query Options"}>
                        <div className="form-group">
                            <label>Include Categories:</label>
                            <Select
                                id = {"categories"}
                                name = {"categories"}
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={selectedCats(attributes.categories)}
                                isMulti
                                options={wpdm_categories}
                                onChange={ ( categories ) => onSelectCategory(categories) }
                            />
                        </div>
                        <div className={"form-group"}>
                            <FormToggle
                                id={"ever"}
                                checked={attributes.include_children}
                                onChange={_include_children => {
                                    setAttributes({include_children: _include_children.target.checked});
                                }}
                            />
                            <label htmlFor={"ever"} style={{paddingLeft: "5px"}}> Include Children</label>
                        </div>
                        <div className="form-group">
                            <SelectControl
                                label={"Category Match:"}
                                value={attributes.operator}
                                class={"form-control wpdm-custom-select"}
                                options={[{label:'Match Exactly', value:'AND'},{label:'Match Any', value:'IN'}]}
                                onChange={ ( operator ) => setAttributes( { operator: operator } ) }
                            />
                        </div>

                        <div className="form-group">
                            <label>Exclude Categories:</label>
                            <Select
                                id = {"xcats"}
                                name = {"xcats"}
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={selectedCats(attributes.xcats)}
                                isMulti
                                options={wpdm_categories}
                                onChange={ ( categories ) => onExcludeCategory(categories) }
                            />
                        </div>

                        <div className="form-group">
                            <TextControl
                                label={"Tags:"}
                                placeholder={"Tags separated by comma"}
                                value={attributes.tag}
                                onChange={ ( tag ) => setAttributes( { tag: tag } ) }
                            />
                        </div>
                        <div className="form-group">
                            <TextControl
                                label={"Exclude Packages With Tags:"}
                                placeholder={"Tags separated by comma"}
                                value={attributes.tag__not_in}
                                onChange={ ( tag__not_in ) => setAttributes( { tag__not_in: tag__not_in } ) }
                            />
                        </div>
                        <div className="form-group">
                            <TextControl
                                label={"Author:"}
                                placeholder={"Author IDs separated by comma"}
                                value={attributes.author}
                                onChange={ ( author ) => setAttributes( { author: author } ) }
                            />
                        </div>
                        <div className="form-group">
                            <TextControl
                                label={"Exclude Package From Authors:"}
                                placeholder={"Author IDs separated by comma"}
                                value={attributes.author__not_in}
                                onChange={ ( author__not_in ) => setAttributes( { author__not_in: author__not_in } ) }
                            />
                        </div>

                    <div className="form-group">
                        <SelectControl
                            label={"Toolbar:"}
                            value={attributes.toolbar}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'Show Toolbar', value:1},{label: "Hide Toolbar", value:0}]}
                            onChange={ ( toolbar ) => setAttributes( { toolbar: toolbar } ) }
                        />
                    </div>
                    <div className="form-group">
                        <SelectControl
                            label={"Order By:"}
                            value={attributes.order_by}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'Publish Date', value:'date'},{label:'Update Date', value:'updated'},{label: "Downloads", value:'download_count'},{label: "Views", value:'view_count'},{label: "Price", value:'base_price'}]}
                            onChange={ ( order_by ) => setAttributes( { order_by: order_by } ) }
                        />
                    </div>
                        <div className="form-group">
                            <SelectControl
                                label={"Order:"}
                                value={attributes.order}
                                class={"form-control wpdm-custom-select"}
                                options={[{label:'Desc', value:'desc'},{label:'Asc', value:'asc'}]}
                                onChange={ ( order ) => setAttributes( { order: order } ) }
                            />
                        </div>


                    <div className="form-group">
                        <TextControl
                            label={"Items Par Page:"}
                            type={"number"}
                            value={attributes.items_per_page}
                            onChange={ ( items_per_page ) => setAttributes( { items_per_page: items_per_page } ) }
                        />
                    </div>


                    <LinkTemplates
                        label = {"Link Template:"}
                        value = {attributes.template}
                        onChange = {onChangeTemplate}
                    />
                    <div className="form-group">
                        <SelectControl
                            label={"Pagination:"}
                            value={attributes.paging}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'Show', value:1},{label: "Hide", value:0}]}
                            onChange={ ( paging ) => setAttributes( { paging: paging } ) }
                        />
                    </div>


                    <div className="form-group">
                        <SelectControl
                            label={"Asynchronous Request:"}
                            value={attributes.async}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'Enabled', value:1},{label: "Disabled", value:0}]}
                            onChange={ ( async ) => setAttributes( { async: async } ) }
                        />
                    </div>
                    </PanelBody>

                </div>
            </InspectorControls>,
            <ServerSideRender
                block = {"download-manager/datatable"}
                attributes = {attributes}
            />
        ]);

    },
    save() {
        return null;
    }
});
